export const VARIANTS = {
  GREEN: 'btn-green60',
  ORANGE: 'btn-orange50',
}
